import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M22 24a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm3 0c0 6.627-5.373 12-12 12S1 30.627 1 24s5.373-12 12-12 12 5.373 12 12ZM13 68c6.627 0 12-5.373 12-12s-5.373-12-12-12S1 49.373 1 56s5.373 12 12 12Zm12 20c0 6.627-5.373 12-12 12S1 94.627 1 88s5.373-12 12-12 12 5.373 12 12Zm27-74c-5.523 0-10 4.477-10 10s4.477 10 10 10h49c5.523 0 10-4.477 10-10s-4.477-10-10-10H52ZM42 88c0-5.523 4.477-10 10-10h38c5.523 0 10 4.477 10 10s-4.477 10-10 10H52c-5.523 0-10-4.477-10-10Zm10-42c-5.523 0-10 4.477-10 10s4.477 10 10 10h22c5.523 0 10-4.477 10-10s-4.477-10-10-10H52Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }